"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject11ToJSON = exports.InlineObject11FromJSONTyped = exports.InlineObject11FromJSON = void 0;
var _1 = require("./");
function InlineObject11FromJSON(json) {
    return InlineObject11FromJSONTyped(json, false);
}
exports.InlineObject11FromJSON = InlineObject11FromJSON;
function InlineObject11FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'message': (0, _1.DiscordRelayMessageMessageFromJSON)(json['message']),
        'botToken': json['botToken'],
    };
}
exports.InlineObject11FromJSONTyped = InlineObject11FromJSONTyped;
function InlineObject11ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'message': (0, _1.DiscordRelayMessageMessageToJSON)(value.message),
        'botToken': value.botToken,
    };
}
exports.InlineObject11ToJSON = InlineObject11ToJSON;
